/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.reports.print.controllers', [
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.validate',
  'acme.common.service.reports',
  'acme.common.service.calendar',
  'acme.common.directive.renderFinish',
  'acme.view.application.reports.print.loadingModal.controllers',
  'acme.common.service.userPreferences'
])

.controller('ReportsPrintController', ['$rootScope', '$scope', '$document', '$timeout', '$filter', '$uibModal', 'ApiService', 'HelpersService', 'ValidateService', 'ReportsService', 'CalendarService', 'UserPreferencesService', function($rootScope, $scope, $document, $timeout, $filter, $uibModal, ApiService, HelpersService, ValidateService, ReportsService, CalendarService, UserPreferencesService) {

  $scope.reportsPrint = {

    model: {},
    report: {},
    date: new Date(),
    numerical: {},
    totals: false,
    hasData: false,
    isLoaded: false,
    printReady: false,
    resizable: false,
    numericColumns: {},
    loadingModal: {},
    progress: 0,
    retrys: 0,
    progressInterval: false,
    grid: {
      pageSize: 10,
      showFooter: false,
      paginate: false,
      columns: []
    },
    isFieldType: ReportsService.isFieldType,
    resizeTimer: null,
    tableRatio: 0,
    dateRangeFormat: UserPreferencesService.getDateFormat('shortDateTime', 'dateFormat'),
    dateTimeFormat: UserPreferencesService.getDateFormat('extendedDate', 'dateFormat') + ' \'at\' ' + UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),
    parts: {
      loading: {
        value: 0,
        type: 'success'
      },
      processing: {
        value: 0,
        type: 'success'
      },
      generating: {
        value: 0,
        type: 'success'
      },
      painting: {
        value: 0,
        type: 'success'
      }
    },

    calculator: {

      setValue: function(part, value, cap) {
        var _part,
          self = $scope.reportsPrint,
          progress = 0;

        self.parts[part].value = value;

        for (_part in self.parts) {
          if (self.parts.hasOwnProperty(_part)) {
            progress += self.parts[_part].value;
          }
        }

        self.progress = Math.ceil(progress / 4);
        $rootScope.$broadcast('ReportsPrintController::Progress', { progress: self.progress });
      },

      getValue: function() {
        return $scope.reportsPrint.progress;
      }

    },

    init: function() {
      this.report = HelpersService.getCookie('report');


      if (this.report) {
        this.getDataSources();
        this.showLoadingModal();
        this.reportEndDateTime = $filter('date')(CalendarService.parseDate(this.report.endDateTime), this.dateRangeFormat);
        this.reportStartDateTime = $filter('date')(CalendarService.parseDate(this.report.startDateTime), this.dateRangeFormat);
      }


      $scope.$on('$destroy', $scope.$on('ngRepeatFinished', function(ngRepeatFinishedEvent) {
        if ($scope.reportsPrint.resizable) {
          $timeout(function () {
            $scope.reportsPrint.resizeTable();
            return true;
          }, 100);
        }
        $scope.reportsPrint.printReady = true;
      }));

      $scope.$on('$destroy', $scope.$on('AppController::print', function(e, data) {
        if ($scope.reportsPrint.printReady) {
          $scope.reportsPrint.printPage();
        }
      }));
      
      $scope.$on('UserPreferencesService:onDateFormatLoad', this.onDateFormatLoad);



      $(window).on('resize', function(e) {
        var self = $scope.reportsPrint;

        if (self.resizable) {
          if (self.resizeTimer) {
            $timeout.cancel(self.resizeTimer);
          }
          self.resizeTimer = $timeout(function () {
            self.resizeTable();
            return true;
          }, 10);
        }
      });

      $scope.$on('$destroy', function() {
        var self = $scope.reportsPrint;
        $timeout.cancel(self.resizeTimer);
      });

      ReportsService.init({
        progress: this.calculator
      });

    },

    showLoadingModal: function() {
      this.loadingModal = $uibModal.open({
        templateUrl: 'views/application/views/reports/print/modals/loading.tpl.html',
        size: 'md',
        backdrop: 'static',
        controller: 'ReportsPrintLoadingModalController',
        resolve: {
          report: function() {
            return $scope.reportsPrint.report;
          },
          runDate: function() {
            return $filter('date')($scope.reportsPrint.date, HelpersService.dateFormats.extendedDateTime);
          },
          retrys: function() {
            return $scope.reportsPrint.retrys;
          }
        }
      });

      // Invoked when modal completes with close(params)
      this.loadingModal.result.then(function (retry) {
        // Do nothing
        if (retry) {
          $scope.reportsPrint.retrys += 1;
          $scope.reportsPrint.getDataSources();
          $scope.reportsPrint.showLoadingModal();
        }
      }, function () {
        // Close window
        window.close();
      });
    },

    resizeTable: function(container, target) {
      var display = $document.find('.reports-print-display'),
        area = (container) ? container : $document.find('.reports-print-summary'),
        table = (target) ? target : area.find('table'),
        ratioX = area.width() / table.width(),
        ratioY = 1,
        bounds = {},
        heightOffset = 0;


      if (this.tableRatio !== ratioX) {
        table.css('transform-origin', '0 0');

        if (!container && !target) {
          table.removeClass('fade-in');
          $timeout(function () {
            console.log('ReportsPrintController::resizeTable', ratioX, ratioY, area.width(), table.width());

            if (ratioX < 1) {
              table.css('transform', 'scale(' + ratioX + ')');
              bounds = table[0].getBoundingClientRect();
              display.css('height', (bounds.height + table.offset().top) + 'px');
            }else{
              table.css('transform', 'scale(1)');
              display.css('height', (table.height() + table.offset().top) + 'px');
            }

            $timeout(function () {
              table.addClass('fade-in');
              return true;
            }, 500);
            return true;
          }, 300);
        } else {
          console.log('ReportsPrintController::resizeTable', ratioX, area.width(), table.width());

          if (ratioX < 1) {
            table.css('transform', 'scale(' + ratioX + ')');
            bounds = table[0].getBoundingClientRect();
            display.css('height', (bounds.height + table.offset().top) + 'px');
          }else{
            table.css('transform', 'scale(1)');
            display.css('height', (table.height() + table.offset().top) + 'px');
          }
        }
        this.tableRatio = ratioX;
      }

    },

    printPage: function() {
      var printArea = $document.find('.reports-print-display'),
        oTable = printArea.find('table'),
        areaClone = printArea.clone(),
        summary = areaClone.find('.reports-print-summary'),
        table = areaClone.find('table'),
        styles = ['<style type="text/css">', 'html, body { width: 100%; }', '</style>'];

      areaClone.addClass('printable');
      areaClone.css({
        height: 'auto',
        width: '100%'
      });

      areaClone.find('.reports-print-heading').clone();

      if (this.resizable && this.tableRatio < 1) {
        //Do MAGIC
        if (this.type === 'summary') {
          areaClone.css('width', oTable.width() + 'px');
        }
        styles[1] = 'html, body { width: '+ oTable.width() +'px;  @media print { @page { margin: 0; } } }';
      }

      table.css({
        'width': '100%',
        'margin': '0 auto',
        'transform-origin': '',
        'transform': ''
      });

      console.log('ReportsPrintController::resizeTable', oTable[0].getBoundingClientRect().width, oTable.width());
      areaClone.print({
        append: styles.join(''),
        renderTimeout: 500
      });
    },

    getDataSources: function() {
      this.isLoaded = false;
      ApiService.reporting.datasources.get(this.report.queryExpression.collectionName).then(this.success.getDataSources, this.error.getDataSources);
    },

    getReport: function () {
      var apiCall = null,
        report = this.report;

      this.isLoaded = false;
      report.queryExpression.limit = 0;

      if (!!report.async) {
        apiCall = ApiService.reporting.asyncReports.getJson(report.id).
          then(function(payload) {
            var jsonPayload = JSON.parse(payload);
            return {
              data: {
                payload: jsonPayload
              }
            };
          });
      } else {
        apiCall = ApiService.reporting.reports.query(report);
      }

      apiCall.then(this.success.getReport, this.error.getReport);
    },

    getDisplayDate: function(date) {
      var _date = date;
      if (this.isUTCDate(date)) {
        _date = $filter('date')(CalendarService.parseDate(date), HelpersService.dateFormats.sortDateTime);
      }
      return _date;
    },

    isGroupFunction: function(fieldName, groupFunction) {
      var r = false,
          groupField = ReportsService.findGroupField(fieldName, this.report.queryExpression);

      if (groupField && groupField.field.groupFunction && groupField.field.groupFunction.toLowerCase() === groupFunction.toLowerCase()) {
        console.log('isGroupFunction', fieldName, groupField, groupFunction);
        r = true;
      }
      return r;
    },

    isUTCDate: function(date) {
      return ValidateService.validators.utcDate(date);
    },

    isNumeric: function(value, field) {
      var r = (ValidateService.validators.number(value));

      if (r && !this.numericColumns[field]) {
        // Only set to true if it is possible
        this.numericColumns[field] = r;
      }else if (this.numericColumns[field]) {
        r = true;
      }

      return r;
    },

    hasColumns: function() {
      return (this.grid.columns.length > 0);
    },

    getLineWeight: function(row) {
      var field,
        count = 0;

      for (field in row) {
        if (row.hasOwnProperty(field)) {
          count++;
        }
      }

      return count;
    },

    setMarkup: function(markup) {
      $('#reports-print-markup').html(markup);
    },

    readyReport: function(props) {

      var self = $scope.reportsPrint;
      self.calculator.setValue('painting', 0);

      ReportsService.generate({
        type: props.type,
        report: {
          grid: props.grid,
          data: props.data,
          totals: props.totals
        }
      }).then(function(markup) {

        self.setMarkup(markup);
        self.isLoaded = true;
        self.printReady = true;
        self.calculator.setValue('painting', 80);

        if (props.resizable) {
          $timeout(function () {
            self.resizeTable();
            self.calculator.setValue('painting', 100);
            return true;
          }, 20);
        }else{
          $timeout(function() {
            self.calculator.setValue('painting', 100);
            return true;
          }, 20);
        }

      });

    },

    success: {
      init: function(response) {},
      getDataSources: function(response) {
        var self = $scope.reportsPrint;
        ReportsService.metaFields = response.data.payload.analyticsFieldMetadataList;
        self.calculator.setValue('loading', 50);
        self.getReport();
      },
      getReport: function(response) {
        var self = $scope.reportsPrint,
            data = ReportsService.parse(response.data.payload, self.report.queryExpression.findFields),
            hasReport = (response.data.payload.hasOwnProperty('summaryReport') && response.data.payload.summaryReport);

        self.calculator.setValue('loading', 100);

        self.grid.pageSize = data.length;
        self.grid.columns = ReportsService.getColumns(response.data.payload.resultFieldList);

        if (hasReport &&
          response.data.payload.summaryReport.grandTotals instanceof Array &&
          response.data.payload.summaryReport.grandTotals.length > 0) {
          self.totals = ReportsService.getTotals(response.data.payload.summaryReport.grandTotals);
          console.log('ReportsPrintController::success::getReport', self.totals);
        }

        if (hasReport &&
          response.data.payload.summaryReport.subTotals instanceof Array &&
          response.data.payload.summaryReport.subTotals.length > 0) {
          ReportsService.summarize(data, response.data.payload.summaryReport).then(function(summary) {
            var k;

            self.model = summary;
            console.log('ReportsPrintController::success::getReport', self.model);
            for (k in self.model) {
              if (self.model.hasOwnProperty(k)) {
                self.hasData = true;
                break;
              }
            }
            self.type = 'summary';
            self.resizable = false;

            self.readyReport({
              type: self.type,
              grid: self.grid,
              data: self.model,
              totals: self.totals,
              resizable: self.resizable
            });

          });
        }else{
          self.model = [{
            values: data,
            totalRecords: data.length
          }];

          self.resizable = true;
          self.hasData = (data.length > 0);
          self.type = 'full';

          self.readyReport({
            type: self.type,
            grid: self.grid,
            data: self.model,
            totals: self.totals,
            resizable: self.resizable
          });

        }


      }
    },

    error: {

      init: function(response) {},

      getDataSources: function(response) {

        var self = $scope.reportsPrint;

        $rootScope.$broadcast('ReportsPrintController::Error', { error: response.error });

        self.isLoaded = true;

        self.calculator.setValue('loading', 100);
        self.calculator.setValue('generating', 100);
        self.calculator.setValue('processing', 100);
        self.calculator.setValue('painting', 100);

      },

      getReport: function(response) {

        var self = $scope.reportsPrint;

        $rootScope.$broadcast('ReportsPrintController::Error', { error: response.error });

        self.isLoaded = true;

        self.calculator.setValue('loading', 100);
        self.calculator.setValue('generating', 100);
        self.calculator.setValue('processing', 100);
        self.calculator.setValue('painting', 100);

      }

    },
    
    onDateFormatLoad: function (e, data) {
      $scope.reportsPrint.dateRangeFormat = UserPreferencesService.getDateFormat('shortDateTime', 'dateFormat');
      $scope.reportsPrint.dateTimeFormat = UserPreferencesService.getDateFormat('extendedDate', 'dateFormat') + ' \'at\' ' + UserPreferencesService.getDateFormat('standardTime', 'hourFormat');
    }

  };

  $scope.reportsPrint.init();

}]);